import { render, staticRenderFns } from "./TargetingCurrentUrl.vue?vue&type=template&id=1b5e8225&"
import script from "./TargetingCurrentUrl.vue?vue&type=script&lang=js&"
export * from "./TargetingCurrentUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports